import { v4 as uuidv4 } from 'uuid'

let traceId: string | null = null

export const TRACE_ID = 'TRACE_ID'

export function generateTraceId(): string {
  if (traceId) return traceId

  const sessionTraceId = sessionStorage.getItem(TRACE_ID)
  traceId = sessionTraceId || uuidv4()

  sessionStorage.setItem(TRACE_ID, traceId)

  return traceId
}

export const setTraceId = (newTraceId: string | null) => {
  traceId = newTraceId
}
